import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { WizardImportConfig } from './models/config.model';

@Injectable({
  providedIn: 'root',
})
export class WizardImportService {
  private wizardConfigSubject = new Subject<WizardImportConfig>();

  constructor() {}

  loadWizard(config: WizardImportConfig) {
    this.wizardConfigSubject.next(config);
  }

  onLoadWizard(): Observable<WizardImportConfig> {
    return this.wizardConfigSubject.asObservable();
  }
}
